const SWEAR_WORDS = [
  "arse",
  "arsehole",
  "asshole",
  "bastard",
  "bitch",
  "bollock",
  "bullshit",
  "cock",
  "crap",
  "cunt",
  "dick",
  "douche",
  "fuck",
  "jackass",
  "jerkoff",
  "nigger",
  "piss",
  "prick",
  "pussy",
  "shit",
  "shite",
  "slut",
  "twat",
  "wank",
  "wanker",
  "whore",
];

export function validateJoinCode(value) {
  if (!value) return "";
  if (/\s/.test(value)) return "Join code must not contain spaces.";
  if (!/^[A-Za-z]+$/.test(value))
    return "Join code can only contain alphabets.";
  if (value.length < 6 || value.length > 8)
    return "Join code must be 6 to 8 characters long.";

  const normalizedValue = value.toLowerCase();
  if (SWEAR_WORDS.some((word) => normalizedValue.includes(word))) {
    return "Join code contains inappropriate language.";
  }

  return "";
}
